import { motion } from "@/lib/motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What does Solved Media actually do?",
    answer: "We generate leads, automate conversations, and re-engage your database using AI—without the usual industry nonsense. Whether it's social media ads, AI chatbots, or data-driven outreach, we focus on getting results, not just selling you a fancy dashboard."
  },
  {
    question: "How does your AI chatbot work?",
    answer: "Think of it as me, but available 24/7 and slightly less sarcastic. It handles customer enquiries, qualifies leads, books appointments, and follows up—without needing coffee breaks or sick days. It's designed to sound natural and actually be useful."
  },
  {
    question: "How much does it cost?",
    answer: "Depends on what you need. Some services are pay-per-lead, some are custom-built solutions, and some pricing (like list data) varies based on volume and quality. No hidden fees, no unnecessary upsells—just tell us what you're after, and we'll give you a straight answer."
  },
  {
    question: "Can you help my business?",
    answer: "If you deal with customers and want more of them, probably. We work with a wide range of industries, from finance to home improvements, and our AI solutions are adaptable. If we think we can't help, we'll tell you—because wasting your time (or ours) isn't how we do business."
  },
  {
    question: "Who do you typically work with?",
    answer: "We work with businesses that want more customers and better systems, not shortcuts. From SMEs to established brands, the common thread is a willingness to be honest about what is not working and improve it properly."
  }
];

export const FAQ = () => {
  return (
    <section className="py-24 relative">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-primary text-sm font-semibold tracking-wider uppercase">
            FAQ
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mt-4 mb-6">
            Frequently Asked <span className="text-gradient">Questions</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.01, x: 4 }}
                transition={{ type: "spring", stiffness: 400, damping: 25 }}
              >
                <AccordionItem
                  value={`item-${index}`}
                  className="glass rounded-xl px-6 border-border/50 data-[state=open]:border-primary/30 hover:border-primary/20 transition-colors"
                >
                  <AccordionTrigger className="text-left text-lg font-medium hover:text-primary transition-colors py-6">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground pb-6 leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
